import React from "react"
import { Route, Routes } from "react-router-dom"
import Header from "./components/Header"
import Home from "./components/Home.js"
import About from "./components/About.js"
import Services from "./components/Services"
import Footer from "./components/Footer"
import Contact from "./components/Contact"
import Thankyou from "./components/Thankyou";



function App() {
  return (
    <React.Fragment>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/thankyou" element={<Thankyou />} />

      </Routes>
      <Footer />
    </React.Fragment>
  )
}

export default App